var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',{attrs:{"text-center":"","wrap":""}},[_vm._v(" CMS 로그 (이벤트 등록, 템플릿 등록) ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }